import { ref } from 'vue';

const url = ref('');

export const useUrlHistory = () => {
    const saveHistoryOfResults = async (newUrl: string) => {
        url.value = newUrl;
    };

    return {
        url,
        saveHistoryOfResults,
    };
};

export default useSubscriptions;
